class ResidenceAppointment {
  id = null;

  firstname = "";
  lastname = "";
  fathername = "";
  mothername = "";
  personalpicturefile = null;
  gender = null;
  maritalstatus = null;
  birthdate = null;
  country = "";
  birthcountry = "";

  passportno = "";
  passporttype = "";
  passportstartdate = null;
  passportenddate = null;
  passportissuingcountry = "";
  passportissuingplace = "";

  province = null; //Turkish: il
  region = null; //Turkish: ilçe
  neighbourhood = null;
  street = null; //Turkish: sokak, cadde
  building = null; //Turkish: bina
  apartment = null; //Turkish: daire
  fulladdress = null; //Turkish:açık adres
  phone = "";
  email = "";
  apartmentresidencedate = null;//date
  incometype = null;
  incomesource = null;
  profession = null;
  durationunit = "";
  duration = 1;
  residencereason = null;
  appointmentno = "";
  type = "Tourism";
  isrenewal = 2;
  verificationtype = "email";
  foreignerno = "";
  startdate = null;
  enddate = null;

  parentappointmentid = null;
  note = "";
  agencyid = null;
  price = 0;
  appointmentpdf = null;
  muracaatbelgesipdf = null;

  foreignersdepartment = null;
  createdby = null;
  updatedby = null;

  nonce = null;

  static getFormData(object) {
    console.log("creating form data .... residence appointment");
    console.log(object);
    const formData = new FormData();
    Object.keys(object).forEach((property) => {
      if (
        object[property] !== null &&
        object[property] !== "-" &&
        object[property] !== "Invalid date"
      ) {
        switch (property) {
          case "appointmentpdf":
          case "muracaatbelgesi":
          case "statusscreenshot":
          case "note":
          case "parentappointmentid":
            formData.append(property, object[property]);
            break;
          case "isrenewal":
            formData.append(
              property,
              object[property] === 0 ? "false" : "true"
            );
            break;
          case "apierror":
            //dont add it
            break;
          default:
            formData.append(property, object[property]);
            break;
        }
      }
    });
    return formData;
  }
}

export default ResidenceAppointment;
